import { useEffect, useState } from "react";
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboards } from "../../../../store/actions/dashsActions";
import { useParams } from "react-router-dom";
import './DashboardViewer.css';

const DashboardViewer = () => {
  const dispatch = useDispatch();
  const { dashs, loading, error } = useSelector((state) => state.dashs);
  const { id } = useParams();
  console.log(dashs)

  useEffect(() => {
    dispatch(fetchDashboards());
  }, [dispatch]);

  if (loading) return <p>Carregando sistema... Por favor, aguarde.</p>;
  if (error) return <p>Erro: {error}</p>;

  return (
    <>
      {dashs && (
        <Helmet>
          <title>
            {dashs.find((da) => da.id === id)?.name}
          </title>
        </Helmet>
      )}

      <div className="dashboard-viewer-container">
        {dashs && <Iframe dashs={dashs} pId={id} />}
      </div>
    </>
  );
};

const Iframe = ({ dashs, pId }) => {
  console.log(dashs)
  const [src, setSrc] = useState("");

  useEffect(() => {
    if (dashs?.length > 0) {
      const selectedDashboard = dashs.find((da) => da.id === pId);
      if (selectedDashboard) {
        setSrc(selectedDashboard.dashboardUrl || ""); // Evita setar src indefinido
      }
    }
  }, [dashs, pId]);

  if (!src) {
    return <p>Carregando...</p>; // Evita que o próprio app seja renderizado no iframe
  }

  return (
    <iframe
      src={src}
      title="Dashboard"
      className="dashboard-iframe" // Utilizando a classe CSS para o iframe
    />
  );
};

export default DashboardViewer;
